<template>
  <div>
    <ViewTemplateReportList :panel="panel" :reports="reports" />
  </div>
</template>

<script>
import ViewTemplateReportList from "@nixweb/nixloc-ui/src/component/template/ViewTemplateReportList";

export default {
  name: "ReportBillingView",
  components: { ViewTemplateReportList },
  data() {
    return {
      panel: {
        module: "Faturamento",
        title: "Relatório",
        showFilter: false,
        showSearch: true,
        showButtons: false,
      },
      reports: {
        default: [
          {
            name: "Fatura",
            description: "",
            routeName: "reportInvoice",
          },
        ],
        saved: [],
      },
    };
  },
};
</script>
